import {generatePath} from '@legit-health/ui';
import {ONE_HOUR_IN_MS} from '@legit-health/ui';
import {COMPANY_FROM_PUBLIC_IDENTIFIER} from '@/shared/const/backend';
import useApiQuery from '@/shared/hooks/useApiQuery';
import useQueryParams from '@/shared/hooks/useQueryParams';

type CompanyResponse = {
  name?: string | null;
  termsAndConditions?: string | null;
  image: string | null;
};

export default function useGetCompanyFromPublicIdentifier() {
  const queryParams = useQueryParams();
  const companyIdentifier = queryParams.get('companyIdentifier');
  const path = generatePath(COMPANY_FROM_PUBLIC_IDENTIFIER, {
    identifier: companyIdentifier ?? 'notused'
  });

  const query = useApiQuery<CompanyResponse>({
    queryOptions: {
      queryKey: [COMPANY_FROM_PUBLIC_IDENTIFIER, companyIdentifier],
      enabled: companyIdentifier !== null,
      staleTime: ONE_HOUR_IN_MS
    },
    requestArguments: {
      method: 'GET',
      path
    }
  });

  if (companyIdentifier === null) {
    return null;
  }
  return query;
}
